var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forum"},[_c('div',{staticClass:"forum__top"},[_c('forum-navbar')],1),_c('div',{staticClass:"forum__bottom"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }